module.exports = __webpack_public_path__ + "img/m2-screenshot-03.e8b12943.png";